
import { Company } from "@/models/company";
import { CompanyModule } from "@/models/company-module";
import { Module } from "@/models/module";
import {ModuleService} from "@/services/module-service";
import AppCompanyInfoModuleMetaData from "./CompanyInfoModuleMetaData.vue";
import Vue from "vue";
import AppCompanyInfoWrapper from "./CompanyInfoWrapper.vue";


export default Vue.extend({
	data() {
		return {
			toShowModule: null as null | CompanyModule,
			columns: [
				{
					name: "Id",
					property: "id",
					width: "50px"
				},
				{
					name: "Name",
					property: "name",
					width: "200px"
				}
			],
			selectedRows: [] as CompanyModule[],
			orderColumn: "id",
			orderDirection: false,
			searchInput: ""
		};
	},
	props: {
		value: {
			type: Object as () => Company,
			required: true
		},
	},
	computed: {
		allModules():Module[] {
			return ModuleService.modules.filter(m => {
				return this.value.modules.findIndex(mod => mod.id == m.id) == -1;
			});
		},
		notAllowedToView():boolean {
			if (this.selectedRows.length != 1) {
				return true;
			} else if (this.selectedRows[0] && !this.selectedRows[0].getEditMetaDataComponent()) {
				return true;
			}
			return false;
		},
		showModuleInfoToolTip():string{
			return "Show Module Information";
		},
		sortedModules():CompanyModule[] {
			let items = [...this.value.modules];
			if (this.searchInput){
				items = items.filter(i=>{
					if (i.name.toLowerCase().indexOf(this.searchInput.toLowerCase()) != -1){
						return true;
					}
					if (`${i.id}`.indexOf(this.searchInput) != -1){
						return true;
					}
					return false;
				});
			}
			items.sort((a,b):number=>{
				if (this.orderColumn == "id") {
					if (this.orderDirection) {
						return a.id - b.id;
					}
					return b.id - a.id;
				}
				if (this.orderDirection) {
					return a.name.localeCompare(b.name);
				}
				return b.name.localeCompare(a.name);
			});
			return items;
		}
	},
	methods: {
		showModuleInfo(module?:CompanyModule){
			if (!module){
				module = this.selectedRows[0];
			}
			if (module.getEditMetaDataComponent() == null){
				return;
			}
			this.toShowModule = module || null;
		},
		closeShowModule(){
			this.toShowModule = null;
		},
		onOrder(event:any) {
			this.orderColumn = event.order;
			this.orderDirection = event.ascending;
		},
	},
	components: {
		AppCompanyInfoModuleMetaData,
		AppCompanyInfoWrapper
	}
});
